// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/elementos_documentos_pdf/save.
 *
 * Creates or updates a PDF page-element via the external html2pdf
 * micro-service (`POST page_elements/create` or `PUT page_elements/{name}`)
 * and forwards the created/updated record back as `dados`. Both upstream
 * handlers return a single serialized gorm PageElement, so the returned
 * record has the same shape as one row of the list/get endpoints and is
 * typed by the sibling ElementosDocumentosPdf_ListRow contract.
 */
import type { ElementosDocumentosPdf_ListRow } from './ElementosDocumentosPdf_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ElementosDocumentosPdf_SaveResponseDados = ElementosDocumentosPdf_ListRow;

export type ElementosDocumentosPdf_SaveResponse = ApiResponse<ElementosDocumentosPdf_SaveResponseDados>;

registerResponseContract('ElementosDocumentosPdf_SaveResponse', {
  _nullable: { type: 'boolean', required: false },
  ID:        { type: 'number',  required: false },
  CreatedAt: { type: 'string',  required: false },
  UpdatedAt: { type: 'string',  required: false },
  DeletedAt: { type: 'string',  required: false },
  type:      { type: 'string',  required: false },
  name:      { type: 'string',  required: false },
  data:      { type: 'string',  required: false },
})
